import React from 'react';
import { PropTypes } from 'prop-types';
// state
import { useDispatch } from 'react-redux';
import { actions as uiActions } from 'state/ui';
// style
import styled, { css } from 'styled-components';
import { media, zIndexses } from 'utils/style';

const MainMenuOverlay = ({ className, isVisible }) => {
  const dispatch = useDispatch();

  return (
    <div
      className={className}
      onClick={() => {
        dispatch(uiActions.toggleMainMenu());
      }}
    ></div>
  );
};

MainMenuOverlay.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool,
};

const regularCSS = css`
  position: absolute;
  top: 0;
  right: 0;
  left: 0px;
  height: 100%;
  opacity: 0;
  z-index: ${zIndexses.mainMenuOverlay};
  pointer-events: none;
  background: #263340;
  transition: opacity 0.3s ease;
`;

const smallDesktopCSS = css`
  background-color: transparent;
  ${(props) =>
    props.isVisible &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;

const tabletCSS = css`
  background: #263340;
  ${(props) =>
    props.isVisible &&
    css`
      opacity: 0.8;
      pointer-events: all;
    `}
`;

const mobileCSS = css`
  opacity: 0;
  pointer-events: none;
`;

export default styled(MainMenuOverlay)`
  ${regularCSS};
  ${media.lessThan('huge')`${smallDesktopCSS}`}
  ${media.lessThan('large')`${tabletCSS}`}
  ${media.lessThan('small')`${mobileCSS}`}
`;
